import React, {
  useState,
  useEffect
} from 'react';

import {SiteLinks} from '../../general';

function ThesisSecondSeminarPageInfo() {
  return (<SiteLinks screen="s2_student_seminar_2" />);
}

export {ThesisSecondSeminarPageInfo};